import { useEffect, useMemo, useRef, useState } from 'react';
import { buildReceiptHtml } from '@/lib/printReceipt';
import { receiptPaperWidth, notaSample } from '@/lib/nota-layout';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog';

export function ReceiptPreviewFrame({ tx, settings, cashier = '', title = 'Pratinjau struk' }) {
  const html = useMemo(() => buildReceiptHtml(tx, settings, cashier, { preview:true }), [tx, settings, cashier]);
  const observer = useRef(null);
  const [state, setState] = useState({ html:null, ready:false, height:100 });
  useEffect(() => () => observer.current?.disconnect(), [html]);
  const loaded = event => {
    observer.current?.disconnect();
    const doc = event.currentTarget.contentDocument;
    if (!doc) return;
    const update = () => {
      const ready = doc.documentElement.dataset.receiptReady;
      if (!ready) return;
      setState({ html, ready:true, height:Math.ceil(doc.body.getBoundingClientRect().height) + 1 });
      observer.current?.disconnect();
    };
    observer.current = new MutationObserver(update);
    observer.current.observe(doc.documentElement, { attributes:true, attributeFilter:['data-receipt-ready'] });
    update();
  };
  const ready = state.html === html && state.ready;
  return <div style={{ width:`${receiptPaperWidth(settings)}mm`, flexShrink:0 }}>
    {!ready && <p role="status" className="text-xs p-2">Memuat font struk…</p>}
    <iframe data-testid="receipt-template-frame" title={title} srcDoc={html} onLoad={loaded}
      style={{ display:'block', width:'100%', height:ready ? state.height : 100, border:0, background:'#fff', visibility:ready ? 'visible' : 'hidden' }} />
  </div>;
}

export default function ReceiptTemplateComparison({ settings }) {
  const [open, setOpen] = useState(false);
  const one = useMemo(() => ({ ...settings, receipt_template:'nota1' }), [settings]);
  const three = useMemo(() => ({ ...settings, receipt_template:'nota3' }), [settings]);
  return <>
    <Button type="button" variant="outline" data-testid="compare-nota" onClick={() => setOpen(true)}>Bandingkan Nota 1 & Nota 3</Button>
    {open && <Dialog open onOpenChange={setOpen}><DialogContent className="bg-ui-card max-w-3xl w-[96vw] max-h-[92dvh] overflow-y-auto">
      <DialogTitle>Perbandingan Nota 1 dan Nota 3</DialogTitle>
      <DialogDescription>Data contoh, bukan transaksi. Skala CSS sama (100%), tanpa pengecilan. Logo dan lebar mengikuti pengaturan di formulir. Geser mendatar pada layar kecil.</DialogDescription>
      <div className="overflow-x-auto" data-testid="nota-comparison"><div className="flex items-start gap-4 w-max">
        <section><h3 className="text-center font-semibold mb-2">Nota 1 · TOTAL 16 px</h3><ReceiptPreviewFrame tx={notaSample} settings={one} cashier="Administrator" title="Nota 1" /></section>
        <section><h3 className="text-center font-semibold mb-2">Nota 3 · TOTAL 20 px</h3><ReceiptPreviewFrame tx={notaSample} settings={three} cashier="Administrator" title="Nota 3" /></section>
      </div></div>
    </DialogContent></Dialog>}
  </>;
}
